// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".annual-leave-dot {\n  display: flex;\n}\n.annual-leave-dot-item {\n  height: 10px;\n  width: 10px;\n  background-color: #bbb;\n  border-radius: 50%;\n  display: inline-block;\n}\n.annual-leave-dot-text {\n  margin: 0 16px 0 6px;\n}", ""]);
// Exports
module.exports = exports;
